<fin-subview
  #subview
  [subviewName]="subviewName"
  [subviewContext]="subviewContext"
  [enableScroll]="(basketOpen$ | async) === false"
  (closeSubViewEvent)="close.emit($event)"
  (shouldCloseSubview)="onClose()"
  [ancillaryLoader$]="ancillaryLoader$"
>
  <ng-container ngProjectAs="header">
    <fin-cms-global-disruption-banner></fin-cms-global-disruption-banner>
    <fin-sub-header
      [showInfoIcon]="(currentStep$ | async)?.phase === STEPS.ANCILLARIES.phase"
      [hasBasket]="true"
      [isBasketDisabled]="false"
      [hasActiveBasketState]="false"
      [hasBasketActionInMobileOnly]="true"
      [backgroundColorClass]="'nordic-blue-900-bg'"
      (openBasket)="openBasket()"
    >
      <fcom-button
        #closeButton
        [theme]="ButtonTheme.DARK_TERTIARY_GHOST"
        [attr.title]="'ancillaries.backToServices' | finLocalization"
        [disabled]="disableButtons$ | async"
        [text]="'ancillaries.backToServices' | finLocalization"
        [icon]="{
          name: SvgLibraryIcon.ARROW_LEFT,
          position: IconPosition.LEFT,
        }"
        class="close-button"
        (clickBtn)="closeSubview()"
      >
      </fcom-button>
    </fin-sub-header>
  </ng-container>

  <ng-container ngProjectAs="main-content">
    <div class="subview-content-sub-wrapper grey-25-bg" #scrollContainer>
      <main class="grid-max-width grid-col-12 grow--min">
        <section class="subview-content grey-25-bg col-f sm-col-1-8 md-col-1-9">
          <section class="inner-grid-content relative">
            <!-- Show the content only when slideIndex could be established -->
            <ng-container *ngIf="boundsOrFlights.length > 0 && slideIndex >= 0">
              <fin-ancillary-header [title]="titleKey | finLocalization">
                <ng-container *ngIf="subtitleMessageKey$ | async as messageKey">
                  <span class="font-body-1">{{ messageKey | finLocalization }}</span>
                </ng-container>
                <fin-ancillary-flight-bound-selector
                  class="pr-large-t mobile-bleed"
                  [showFlightCard$]="showFlightCard$"
                  [boundsOrFlights]="boundsOrFlights"
                  [passengers]="passengers$ | async"
                  [activeBoundIndex]="slideIndex"
                  (selectIndex)="updateSlideIndex($event, false)"
                  [locations]="locations"
                  (viewDetails)="viewDetails()"
                  [focusOnDetails$]="itineraryModalClosed$"
                >
                </fin-ancillary-flight-bound-selector>
              </fin-ancillary-header>
            </ng-container>

            <div class="overflow-hidden mobile-bleed">
              <div class="slider nowrap fill slide-{{ slideIndex }}">
                <ng-content></ng-content>
              </div>
            </div>

            <div #ctaButtonHeightFixRef></div>
          </section>
        </section>
        <aside class="subview-cart grow sm-col-9-12 md-col-10-12 grey-50-bg" [class.open]="basketOpen$ | async">
          <fin-booking-summary
            [unpaidServices$]="unpaidServices$"
            [currentStep$]="currentStep$"
            [onlyShowAncillaries]="onlyShowAncillaries"
            [flowContext]="subviewContext"
            [hideChangeButton]="hideChangeButton"
            (close)="closeBasket()"
            (edit)="onEdit($event)"
          ></fin-booking-summary>
        </aside>
      </main>
    </div>
  </ng-container>

  <ng-container ngProjectAs="global-content">
    <fin-ancillary-sidebar
      *ngIf="category !== Category.COVER && hideSideBar === false"
      [category$]="category | finToObservable"
      [isSideBarOpen]="isSideBarOpen"
      [boundsOrFlights$]="boundsOrFlights | finToObservable"
      [locations]="locations"
      [passengers]="(cartOrOrder$ | async).passengers"
      [purchasedServices$]="purchasedServices$"
      [showFareFamily]="showFareFamilyInAncillarySidebar"
      (ctaSideBarClosed)="closeSubview()"
      (sideBarClosed)="closeSidebar()"
      (changeSelectedIndex)="updateSlideIndex($event, true)"
      [availability$]="boundOrFlightAncillaryAvailability$"
      [subTotalPrice$]="subTotalPrice$"
      [skipEnabled]="skipEnabled"
      [skipText]="skipText"
      [maxedOutForFragment$]="maxedOutForFragment$"
      [passengersWithPetcIncompatibleSeats$]="passengersWithPetcIncompatibleSeats$"
    >
    </fin-ancillary-sidebar>

    <fcom-cta-button
      data-testid="common-booking-ancillaries-subview-cta-button"
      *finLet="showFlightCard$ | async as showFlightCard"
      [visible]="(showCtaButton$ | async) && (ancillaryLoader$ | async) === AncillaryLoaderStatus.OFF"
      [title]="ctaButtonTitle | finLocalization"
      [position]="ButtonPosition.GRID"
      [disabled]="disableButtons$ | async"
      [isTabletUp]="isTabletUp$ | async"
      [showSecondaryButton]="hideSideBar"
      [secondaryButtonDisabled]="secondaryButtonDisabled$ | async"
      [secondaryButtonTitle]="'services.productCards.goToReview' | finLocalization"
      (secondaryButtonClicked)="handleSecondaryCtaClick()"
      (buttonClicked)="handleCtaClick(showFlightCard)"
    >
      <ng-container *ngIf="!showFlightCard">
        <span class="gray-50-text">{{ 'subtotal' | finLocalization }}: </span>
        <span class="font-body-1">{{ subTotalPrice$ | async | finPrice | finEmpty: '&ndash;' }}</span>
      </ng-container>
      <span class="flex flex--center" *ngIf="showFlightCard">
        <span class="flex-1 flex--basis0">
          <span class="gray-50-text">{{ 'subtotal' | finLocalization }}: </span>
          <span class="font-body-1">{{ subTotalPrice$ | async | finPrice | finEmpty: '&ndash;' }}</span>
          <ng-container *ngIf="category === Category.SEAT && (reassignFreeSeatsVisible$ | async)">
            <div class="flex flex--column">
              <button data-testid="reassign-seat-button" class="underline" (click)="reassignFreeSeats()">
                <b>{{ 'ancillaries.seats.reassignFreeSeat' | finLocalization }}</b>
                <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_BACK"></fcom-icon>
              </button>
            </div>
          </ng-container>
        </span>
        <ng-container *ngIf="category !== Category.SEAT && hideSideBar === false">
          <span
            class="flex--nogrow rounded-medium white-bg ms-large-x"
            [style.width.rem]="0.1"
            [style.height.rem]="1.2"
            *ngIf="slideIndex < boundsOrFlights.length - 1"
          ></span>
          <span class="flex-1 flex--basis0" *ngIf="slideIndex < boundsOrFlights.length - 1">
            <button data-testid="view-summary-button" class="underline" (click)="onClose()">
              {{ 'services.productCards.viewSummary' | finLocalization }}
            </button>
          </span>
        </ng-container>
      </span>
    </fcom-cta-button>

    <fcom-modal
      *ngIf="category !== Category.COVER"
      class="itinerary-modal"
      [title]="'itinerary.title' | finLocalization"
      [buttons]="ModalButtons.DONE"
      (close)="itineraryModalClosed$.emit(true)"
      [(open)]="itineraryModal.open"
    >
      <fin-itinerary
        *ngIf="itineraryModal.data && (itineraryModal.data.outbound$ || itineraryModal.data.inbound$)"
        class="block pr-medium"
        [selectionPhase$]="itineraryModal.data.selectionPhase$"
        [outbound$]="itineraryModal.data.outbound$"
        [inbound$]="itineraryModal.data.inbound$"
        [locations$]="itineraryModal.data.locations$"
      >
      </fin-itinerary>
    </fcom-modal>
    <ng-container *ngIf="confirmModalData$ | async as confirmModalData">
      <fcom-modal
        data-testid="ancillary-subview-confirmation-modal"
        *ngIf="confirmModalData?.confirmData?.confirmationModalTranslationKeys as confirmationModalTranslationKeys"
        [open]="confirmModalData.open"
        [fitToContent]="true"
        [title]="confirmationModalTranslationKeys.title | finLocalization"
        [buttons]="ModalButtons.CUSTOM"
        (close)="closeConfirmModal.emit()"
        [id]="'confirmationModal'"
      >
        <div class="mr-large-x mr-small-y font-body-1 nordic-blue-900-text">
          <p>{{ confirmationModalTranslationKeys.firstContentParagraph | finLocalization }}</p>
          <p class="mr-xsmall-t">{{ confirmationModalTranslationKeys.secondContentParagraph | finLocalization }}</p>
        </div>
        <div buttons>
          <fcom-button
            [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
            (clickBtn)="closeConfirmModal.emit()"
            [text]="confirmationModalTranslationKeys.closeButton | finLocalization"
            [aria]="{ label: 'actions.cancel' | finLocalization, role: 'button' }"
            class="mr-xsmall-r"
            data-testid="confirm-modal-close"
          ></fcom-button>
          <fcom-button
            (clickBtn)="closeConfirmModal.emit(confirmModalData.confirmData)"
            [text]="confirmationModalTranslationKeys.continueButton | finLocalization"
            [aria]="{ label: 'actions.continue' | finLocalization, role: 'button' }"
            class="mr-xsmall-r"
            data-testid="confirm-modal-continue"
          ></fcom-button>
        </div>
      </fcom-modal>
    </ng-container>
  </ng-container>
</fin-subview>
